import { render } from "./the-ebooks-card.vue?vue&type=template&id=12948046&scoped=true&ts=true"
import script from "./the-ebooks-card.vue?vue&type=script&lang=ts"
export * from "./the-ebooks-card.vue?vue&type=script&lang=ts"

import "./the-ebooks-card.vue?vue&type=style&index=0&id=12948046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12948046"]])

export default __exports__